import { Injectable, Directive, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { IFieldConfig, Field } from '../../../../models';
import { AppFormComponent } from '../form';
import { FormsService } from '../../services';

@Directive()
@Injectable()
export abstract class FieldBaseComponent implements Field {
  fc = inject(AppFormComponent);
  formService = inject(FormsService);

  config!: IFieldConfig;

  get formGroup(): UntypedFormGroup {
    return this.fc.form;
  }

  showAsterisk(config: IFieldConfig): boolean {
    return this.formService.showIndicator(config);
  }

  get valid(): boolean {
    return this.fc.controls[this.config.name].valid && (this.fc.controls[this.config.name].touched || this.fc.submitted);
  }

  get invalid(): boolean {
    return this.fc.controls[this.config.name].invalid && (this.fc.controls[this.config.name].touched || this.fc.submitted);
  }
}
